<template>
  <!-- 创新产业集群榜-->
  <div class="section-scene city">
      <div class="city-enter">
        <div class="right-bg"></div>
      </div>
      <img :src="static_img_url + 'pic/index/logo.png'" class="main-logo">
      <div class="container">
          <div class="left-body">
            <div class="content content-enter">
                <div>
                  <p><img :src="static_img_url + 'pic/index/logo1.png'" class="logo-vb100"></p>
                </div>
                <div>
                    <p class="gold-tle">创新产业集群榜</p>
                </div>
                <div>
                  <p class="summary">
                    寻找未来医疗产业坐标
                  </p>
                </div>
                <div>
                  <a href="http://vcbeat-vb100.mikecrm.com/xafkheC" target="_blank" class="city-href">报名参选</a>
                </div>
            </div>
            <div class="bom-container">
                <div class="translate-down"></div>
                <div></div>
                <div class="translate-right translate-lowerRight">
                  <!-- <a href="https://vcbeat.top/Forum/summitList" target="_blank">
                    <img :src="static_img_url + 'pic/index/city_bg1.png'">
                  </a> -->
                  <img :src="static_img_url + 'pic/index/city_bg1.png'">
                </div>
                <div class="city-swiper translate-down">
                  <div class="city-item">
                      <div class="city-desc">
                        <p>本榜单主要覆盖全国各省份医疗创新型产业集群（含国家级产业园区），通过对产业集群实力进行综合评估，最终形成未来医疗100强榜·创新产业集群榜，以期更好地聚焦透视、全维解码医疗创新产业集群格局，为各地政府招商、投资机构投资及企业落地选址提供决策支撑。</p>
                        <p>榜单所提及的医疗创新型产业是以生物技术、新材料和智能制造、数字技术三大技术集群为基础，以疾病预防、诊断、治疗为目的形成的高新技术产业，主要涉及生物医药、医疗器械、数字医疗三个领域。</p>
                      </div>
                  </div>
                </div>
            </div>
          </div>
          <div class="r-body">
              <img :src="static_img_url + 'pic/index/city_rank_pic.png'">
          </div>
      </div>
      <div class="city-leave"></div>
  </div>
</template>

<script>
import { anima_mixins } from 'js/anima_mixins.js'
import { timeoutSync } from 'js/common.js'

export default {
  mixins:[anima_mixins],
  data() {
    return {
      static_img_url: process.env.VUE_APP_CDN,
      defaultPage: 4
    };
  },
  methods:{
    async downEnter(){
      // console.log('city:下 进入')
      let $divs = $('.bom-container >div')
      await timeoutSync(() => {
        $divs.eq(0).removeClass('translate-down')
        $divs.eq(2).removeClass('translate-lowerRight')
        $divs.eq(3).removeClass('translate-down')
        $('.content').removeClass('content-enter')
      },100)
      $('.city-enter').addClass('city-enter-end')
      await timeoutSync(() => {
        $divs.eq(2).removeClass('translate-right')
      },400)
      await timeoutSync(() => {
        this.$emit('setLock',true)
      },700)
    },
    async upEnter(){
      // console.log('city:上 进入')
      let $divs = $('.bom-container >div')
      await timeoutSync(() => {
        $('.city-leave').removeClass('city-leave-02')
        $('.city-leave').removeClass('city-leave-01')
      },50)
      await timeoutSync(() => {
        $divs.eq(2).removeClass('translate-down')
        $divs.eq(0).removeClass('translate-down')
        $divs.eq(3).removeClass('translate-down')
        $('.content').removeClass('content-enter')
      },200)
      await timeoutSync(() => {
        this.$emit('setLock',true)
      },600)
    },

    async upLeave(){
      // console.log('city:上 退出 ')
      let $divs = $('.bom-container >div')
      $divs.eq(2).addClass('translate-right')
      $divs.eq(0).addClass('translate-down')
      $divs.eq(2).addClass('translate-lowerRight')
      $divs.eq(3).addClass('translate-down')
      $('.content').addClass('content-enter')
      $('.city-enter').removeClass('city-enter-end')
      await timeoutSync(() => {
        this.$emit('setActivePage',this.nextPage)
      },600)
    },
    async downLeave(){
      // console.log('city:下 退出 ')
      let $divs = $('.bom-container >div')
      $('.city-leave').addClass('city-leave-01')
      $divs.eq(2).addClass('translate-down')
      $divs.eq(3).addClass('translate-down')
      $divs.eq(0).addClass('translate-down')
      $('.content').addClass('content-enter')
      await timeoutSync(() => {
        $('.city-leave').addClass('city-leave-02')
      },600)
      await timeoutSync(() => {
        this.$emit('setActivePage',this.nextPage)
      },350)
    }
  }
};
</script>

<style lang="stylus" scoped>
@import '~styles/common.stylus';
@import '~styles/animation.stylus';

.city
  .city-enter
    position absolute
    top 0
    width 100vw
    height 100vh
    >div
      position absolute
      height 100vh
      background #232323
      transition all .6s
    .left-bg
      left 0
      width px2vw(1200)
    .right-bg
      right 0
      width px2vw(720)
  .city-enter-end
    .right-bg
      width 0
  .container
      display flex
      flex-direction row
      .left-body
          position relative
          width px2vw(1200)
          // min-width 800px
          height 100vh
          background #232323
          padding-left px2vw(240)
          .content
              position relative
              top px2vh(300)
              .logo-vb100
                  height px2vh(75)
              .gold-tle
                  margin-top 40px
              .summary
                  margin-top 40px
                  font-size:32px;
                  color:#FFFFFF
              .city-href
                display inline-block
                width:160px;
                height:46px;
                font-size 16px
                background:linear-gradient(-45deg,rgba(214,162,77,1),rgba(255,215,149,1));
                border-radius:23px;
                text-align center
                color #000000
                line-height 46px;
                margin-top 30px
                &:hover
                    color #ffffff
              @media screen and (max-width: 1366px)
                .gold-tle
                  margin-top 30px
                  font-size 40px !important
                .summary
                  margin-top 30px
                  font-size:20px;
          .bom-container
              position absolute
              bottom 0
              left 0
              display flex
              flex-direction row
              width 100%
              >div
                  margin-top auto
                  transition all .4s
              >div:nth-child(1)
                  position absolute
                  bottom 0
                  width 100%
                  height px2vh(220)
                  background #ffffff
              >div:nth-child(2)
                  width px2vw(220)
                  // width 220px
                  height px2vh(220)
              >div:nth-child(3)
                  position relative
                  z-index 1
                  width px2vw(440)
                  // width 440px
                  height px2vh(350)
                  background #113D96
                  img 
                    display block
                    position absolute
                    width 100%
                    height 100%
                    object-fit: cover
                    object-position: 50% 50%
              >.city-swiper
                  position relative
                  z-index 2
                  width px2vw(540)
                  // width 540px
                  height px2vh(440)
                  background #000000
                  .city-item
                    width 100%
                    height 100%
                    color #FFFFFF
                    overflow hidden
                    .city-tle
                      font-size:22px;
                    .city-desc
                      font-size:14px;
                      line-height:22px;
                      height 100%
                      padding px2vw(60) px2vw(60) 0 px2vw(60)
                      overflow auto
                      @media screen and (max-width: 1366px)
                        padding px2vh(30) px2vw(30)
                      // margin-top 20px
                      p + p
                        margin-top 10px
                      @media screen and (max-width: 1366px)
                        font-size:12px;
                        line-height:20px;
                        p + p
                          margin-top 5px
                  
      .r-body
          width px2vw(720)
          height 100vh
          img 
              width: 100%
              height 100%
              object-fit: cover
              object-position: 50% 50%
  .city-leave
    position absolute
    width px2vw(220)
    height 0
    left 0
    bottom 0
    background #ffffff
    transition all .4s
    z-index 20
    &.city-leave-01
      height 100vh
    &.city-leave-02
      width 120vw
</style>